<template>
  <SiteSponsorMarquee />
</template>
